export default __webpack_public_path__ + "static/media/cain8.a14d71b7.jpg";